import React from 'react';
import {
  FiCamera, FiCalendar, FiMail, FiPhone, FiCopy,
  FiCheckCircle, FiSlash, FiRotateCcw, FiAtSign,
} from 'react-icons/fi';
import { ROL_LABELS, ESTADO_LABELS_LARGO, DEPTO_LABELS, esStaff } from '../../../../constants/usuarios';

const formatearAlta = (fecha) => new Date(fecha).toLocaleDateString('es-ES', {
  day: 'numeric', month: 'long', year: 'numeric',
});

/**
 * Cabecera del perfil: identidad, estado y las acciones que más se repiten
 * (copiar contacto, verificar o suspender sin entrar en los ajustes).
 */
const HeroUsuario = ({
  usuarioData,
  fotoActual,
  subiendoFoto,
  onCambiarFoto,
  puedeCambiarEstado,
  cambiandoEstado,
  onCambiarEstado,
  onCopiar,
}) => {
  const estadoActual = usuarioData.estado || 'verificado';
  const rolStaff = esStaff(usuarioData.role);

  return (
    <div className={`perfil-hero perfil-hero--${estadoActual}`}>
      {/* Fila 1: quién es y qué se puede hacer con él */}
      <div className="perfil-hero-principal">
        <div className="perfil-hero-avatar-wrap">
          <img className="perfil-hero-avatar" src={fotoActual} alt={`Foto de ${usuarioData.nombre}`} />
          <button
            type="button"
            className="perfil-hero-avatar-btn"
            onClick={onCambiarFoto}
            disabled={subiendoFoto}
            title="Cambiar foto de perfil"
            aria-label="Cambiar foto de perfil"
          >
            {subiendoFoto
              ? <span className="btn-spinner" style={{ borderTopColor: '#fff', width: 12, height: 12 }} />
              : <FiCamera />}
          </button>
        </div>

        <div className="perfil-hero-identidad">
          <div className="perfil-hero-nombre-row">
            <h1>{usuarioData.nombre} {usuarioData.apellidos}</h1>
            <button
              type="button"
              className="perfil-hero-usuario"
              onClick={() => onCopiar(usuarioData.usuario, 'Usuario copiado')}
              title="Copiar usuario"
            >
              <FiAtSign />{usuarioData.usuario}
              <FiCopy className="perfil-dato-copiar" />
            </button>
          </div>

          {/* Rol y estado: el color va en el punto del badge, sin icono que lo repita */}
          <div className="perfil-hero-badges">
            <span className={`perfil-badge perfil-badge-rol-${usuarioData.role}`}>
              {ROL_LABELS[usuarioData.role] || 'Usuario'}
            </span>
            <span className={`perfil-badge perfil-badge-estado-${estadoActual}`}>
              {ESTADO_LABELS_LARGO[estadoActual]}
            </span>
            {rolStaff && (
              <span className="perfil-badge perfil-badge-dept">
                {DEPTO_LABELS[usuarioData.dpto_tecnico] || 'Sin departamento'}
              </span>
            )}
          </div>
        </div>

        {puedeCambiarEstado && (
          <div className="perfil-hero-acciones">
            {estadoActual !== 'verificado' && (
              <button
                type="button"
                className="perfil-btn-accion perfil-btn-accion--ok"
                onClick={() => onCambiarEstado('verificado')}
                disabled={cambiandoEstado}
              >
                {estadoActual === 'suspendido' ? <><FiRotateCcw /> Reactivar</> : <><FiCheckCircle /> Verificar</>}
              </button>
            )}
            {estadoActual !== 'suspendido' && (
              <button
                type="button"
                className="perfil-btn-accion perfil-btn-accion--peligro"
                onClick={() => onCambiarEstado('suspendido')}
                disabled={cambiandoEstado}
              >
                <FiSlash /> Suspender
              </button>
            )}
          </div>
        )}
      </div>

      {/* Fila 2: contacto en celdas con rótulo, en vez de un renglón corrido */}
      <div className="perfil-hero-datos">
        <div className="perfil-hero-dato">
          <span className="perfil-hero-dato-label"><FiMail /> Email</span>
          {usuarioData.email ? (
            <span className="perfil-hero-dato-valor">
              <a href={`mailto:${usuarioData.email}`} title="Escribir un email">{usuarioData.email}</a>
              <button
                type="button"
                className="perfil-dato-accion"
                onClick={() => onCopiar(usuarioData.email, 'Email copiado')}
                title="Copiar email"
                aria-label="Copiar email"
              >
                <FiCopy />
              </button>
            </span>
          ) : (
            <span className="perfil-hero-dato-valor perfil-hero-dato-valor--vacio">Sin email</span>
          )}
        </div>

        <div className="perfil-hero-dato">
          <span className="perfil-hero-dato-label"><FiPhone /> Teléfono</span>
          {usuarioData.telefono ? (
            <span className="perfil-hero-dato-valor">
              <a href={`tel:${usuarioData.telefono}`} title="Llamar">{usuarioData.telefono}</a>
              <button
                type="button"
                className="perfil-dato-accion"
                onClick={() => onCopiar(usuarioData.telefono, 'Teléfono copiado')}
                title="Copiar teléfono"
                aria-label="Copiar teléfono"
              >
                <FiCopy />
              </button>
            </span>
          ) : (
            <span className="perfil-hero-dato-valor perfil-hero-dato-valor--vacio">Sin teléfono</span>
          )}
        </div>

        <div className="perfil-hero-dato">
          <span className="perfil-hero-dato-label"><FiCalendar /> Alta</span>
          <span className="perfil-hero-dato-valor">{formatearAlta(usuarioData.createdAt)}</span>
        </div>
      </div>
    </div>
  );
};

export default HeroUsuario;
